import { adminPath, type AdminClient } from '../../modules/core/index.js'
import { readMarked, type Marked } from '../../modules/add-ons/index.js'
import type { ExportBatch, PerformanceSummary, PerformanceSummaryListItem } from './types.js'

/** The Performance Summaries add-on's read-only admin mirrors: each answer carries where the add-on stands at the facility. */
export interface PerformanceReviewsAdminApi {
  performanceSummaries(clientId: string, workerId: string): Promise<Marked<PerformanceSummaryListItem[]>>
  performanceSummary(clientId: string, workerId: string, summaryId: string): Promise<Marked<PerformanceSummary>>
  /** The same summary as its CSV text. */
  performanceSummaryCsv(clientId: string, workerId: string, summaryId: string): Promise<string>
  performanceExports(clientId: string, facilityId: string): Promise<Marked<ExportBatch[]>>
}

/** Built by the add-on's own admin sections from the client the registry hands them, as the add-on mounts its own routes on the API. */
export function createPerformanceReviewsAdminApi(client: AdminClient): PerformanceReviewsAdminApi {
  const summaries = (clientId: string, workerId: string): string => `${adminPath.worker(clientId, workerId)}/performance-summaries`
  return {
    performanceSummaries: (clientId, workerId) => readMarked(client, summaries(clientId, workerId)),
    performanceSummary: (clientId, workerId, summaryId) => readMarked(client, `${summaries(clientId, workerId)}/${encodeURIComponent(summaryId)}`),
    performanceSummaryCsv: (clientId, workerId, summaryId) => client.text(`${summaries(clientId, workerId)}/${encodeURIComponent(summaryId)}?format=csv`, 'text/csv'),
    performanceExports: (clientId, facilityId) => readMarked(client, `${adminPath.facility(clientId, facilityId)}/performance-summaries/exports`),
  }
}
